import { EventEmitter, Injectable, Output } from '@angular/core';
import { TranslationService } from '@spartacus/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Constants } from 'src/app/core/constants/url.constants';
import { HttpUtilService } from 'src/app/core/services/http-util.service';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { HttpClient } from '@angular/common/http';
import { map, switchMap } from 'rxjs/operators';
import { WindowRef } from '@spartacus/core';
import { FormGroup } from '@angular/forms';
@Injectable({
  providedIn: 'root'
})
export class CustomProfileService {
  userid;
  private languageChange = new BehaviorSubject(null);
  languageChange$ = this.languageChange.asObservable();
  lang = 'en';
  usergroup = '';
  companyNameChange = new BehaviorSubject(0);
  @Output() changeGroupCompany = new EventEmitter<string>();
  companyNameChange$ = this.companyNameChange.asObservable();
  private userIdChange = new BehaviorSubject(null);
  userIdChange$ = this.userIdChange.asObservable()
   private portInvTypeList = new BehaviorSubject<any[]>([]);
  portInvTypeListObv = this.portInvTypeList.asObservable();
    private screeningInvTypeList = new BehaviorSubject<any[]>([]);
  screeningInvTypeListObv = this.screeningInvTypeList.asObservable();

  localUserID:string
  constructor(private httpUtilService: HttpUtilService,
              private translation: TranslationService,
              private userAccountFacade: UserAccountFacade,
              private httpClient:HttpClient,
              private winRef: WindowRef
  ) {
    this.translation.translate('home.myAccount.language').subscribe(res => {
      this.lang = res;
      this.getLanguageChange(res);
    });
    this.userAccountFacade.get().subscribe(data => {
      if (data) {
        this.userid = data.uid;
        this.userIdChange.next(this.userid);
        this.usergroup = this.winRef.localStorage.getItem('groupCompany');
      }
    });
    this.localUserID = localStorage.getItem('staticUserValue') ? localStorage.getItem('staticUserValue') : '';
  }
  private templateData$: BehaviorSubject<any> = new BehaviorSubject(null);
  getTemplateData(): Observable<any> {
    return this.templateData$.asObservable();
  }
  setTemplateData(template: any) {
    this.templateData$.next(template);
  }
   private bidsordersname$: BehaviorSubject<string|null> = new BehaviorSubject(null);
  getbidsOrdersData(): Observable<any> {
    return this.bidsordersname$.asObservable();
  }
  setbidsOrderseData(orders: any) {
    this.bidsordersname$.next(orders);
  }
  resetTemplateData(){
   this.templateData$.next({});
  }
  getLanguageChange(value): any {
    this.languageChange.next(value);
  }
  private portData$: BehaviorSubject<any> = new BehaviorSubject(null);
  getports(): Observable<any> {
    return this.portData$.asObservable();
  }
  setports(template: any) {
    this.portData$.next(template);
  }
  resetportFilter(){
    this.portData$.next({})

  }
  private bidFormState$: BehaviorSubject<FormGroup|null>= new BehaviorSubject(null);
setBidForm(form:FormGroup){
  this.bidFormState$.next(form);
}
getBidForm():Observable<any>{
  return this.bidFormState$.asObservable();
}
getCurrentBidForm():FormGroup|null{
  return this.bidFormState$.value
}
clearBidForm(){
  this.bidFormState$.next(null);
}
  private agentData$: BehaviorSubject<any> = new BehaviorSubject(null);
  getagents(): Observable<any> {
    return this.agentData$.asObservable();
  }
  setagents(template: any) {
    this.agentData$.next(template);
  }
  resetagentFilter(){
    this.agentData$.next({})

  }
  private searchdata$: BehaviorSubject<any> = new BehaviorSubject(null);
  getsearch(): Observable<any> {
    return this.searchdata$.asObservable();
  }
  setsearch(template: any) {
    this.searchdata$.next(template);
  }
  resetsearchFilter(){
    this.searchdata$.next({})

  }
  private statusData$: BehaviorSubject<any> = new BehaviorSubject(null);
  getstatus(): Observable<any> {
    return this.statusData$.asObservable();
  }
  setstatus(template: any) {
    this.statusData$.next(template);
  }
  resetstatusFilter(){
    this.statusData$.next({})

  }
  private startDate$: BehaviorSubject<any> = new BehaviorSubject(null);
  getstartDate(): Observable<any> {
    return this.startDate$.asObservable();
  }
  setstartDate(template: any) {
    this.startDate$.next(template);
  }
  resetstartDateFilter(){
    this.startDate$.next({})

  }
  private endDate$: BehaviorSubject<any> = new BehaviorSubject(null);
  getendDate(): Observable<any> {
    return this.endDate$.asObservable();
  }
  setendDate(template: any) {
    this.endDate$.next(template);
  }
  resetendDateFilter(){
    this.endDate$.next({})

  }
  getGroupCompanies(usergroup): Observable<any> {
    this.getGroupCompany();
    return this.httpUtilService.get(Constants.profileData(this.userid, this.usergroup).GROUP_COMPANIES, 'token');
  }
  getcontacts(usergroup): Observable<any> {
    this.getGroupCompany();
    return this.httpUtilService.get(Constants.profileData(this.userid, this.usergroup).CONTACTS);
  }
  getGroupUser(usergroup): Observable<any> {
    this.getGroupCompany();
    return this.httpUtilService.get(Constants.profileData(this.userid, this.usergroup).MASTERDATA);
  }
  createUpdateUser(usergroup, userForm): Observable<any> {
    this.getGroupCompany();
    return this.httpUtilService.post(Constants.profileData(this.userid, this.usergroup).ADDCONTACTS, userForm);
  }
  updateUser(usergroup, userForm, queryString): Observable<any> {
    this.getGroupCompany();
    return this.httpUtilService.post(Constants.profileData(this.userid, this.usergroup).UPDATECONTACTS + queryString, userForm);
  }
  getAddressBookData(usergroup?): Observable<any> {
    this.getGroupCompany();
    return this.httpUtilService.get(Constants.profileData(this.userid, this.usergroup).ADDRESS_BOOK);
  }
  getTeamData(usergroup?): Observable<any> {
    this.getGroupCompany();
    return this.httpUtilService.get(Constants.profileData(this.userid, this.usergroup).BHPTEAM);
  }
  getMasterData(usergroup?): Observable<any> {
    this.getGroupCompany();
    return this.httpUtilService.get(Constants.profileData(this.userid, this.usergroup).MASTERDATA);
  }
  updateCompanyDetails(queryString, usergroup?): Observable<any> {
    this.getGroupCompany();
    return this.httpUtilService.put(Constants.profileData(this.userid, this.usergroup).SAVE_GROUP_COMPANIES_DATA + queryString, {});
  }
  crrentUserInfo(): Observable<any> {
    return this.httpUtilService.get(Constants.profileData(this.userid).CURRENTUSERDATA);
  }
  resetPassword(token, password): Observable<any> {
    const data = {
      accesstoken: token,
      newpassword: password
    };
    return this.httpUtilService.post(Constants.RESET_PASSWORD, data);
  }
  forgotPassword(username,preference): Observable<any> {
    const data = {
      userid: username
    };
    return this.httpUtilService.post(Constants.forgotPassword(username, preference).FORGET_PASSWORD, data);
  }

  changePasswordToken(username): Observable<any> {
    const data = {
      userid: username
    };
    return this.httpUtilService.post(Constants.changePasswordToken(username).CHANGE_PASSWORD_TOKEN, data);
  }

  getNotificationCount(): Observable<any> {
    this.getGroupCompany();
    return this.httpUtilService.get(Constants.profileData(this.userid, this.usergroup).NOTIFICATIONCOUNT);
  }
  getBhpUnitList(): Observable<any> {
  return this.httpUtilService.get(Constants.profileData(this.userid).BHPUNITLIST);
  //  const data = this.httpClient.get("/assets/b2bunits.json");
  //  console.log(data);
  //  return data;
  }
  getBhpData(email: any): Observable<any> {
    return this.httpUtilService.get(Constants.profileData(email).BHPUNITLIST);
    }
  getGroupCompany(): any{
    this.usergroup = this.winRef.localStorage.getItem('groupCompany');
    return this.usergroup;
  }

  getContactData(currentPage?):any{
    // return this.httpClient.get(Constants.getTenders(this.userid,this.userGroup,currentPage).TENDERS_DATA).pipe(map((response: any) => response));
    return this.httpClient.get("/assets/contactList.json").pipe(map((response: any) => response));
   }
   getConsentUpdateDetails(userId,lastConsentModified_Terms,currentDocDate_Privacy,currentDocDate_Terms,lastConsentModified_Privacy): Observable<any>{
    return this.httpUtilService.get(Constants.consentUpdateDetails(userId,lastConsentModified_Terms,currentDocDate_Privacy,currentDocDate_Terms,lastConsentModified_Privacy).CONSENT_UPDATE_DETAILS);
   }
   updateUserConsents(uId): Observable<any> {
    const data = {
      uid: uId
    }
    return this.httpUtilService.post(Constants.updateUserConsents(this.userid,uId).UPDATE_USER_CONSENTS, data);
   }

   companyChangeClicked(){
    this.changeGroupCompany.emit('clicked');
   }

   shipmentDetail(queryParams?:any) {
     const userid = localStorage.getItem('staticUserValue') ? localStorage.getItem('staticUserValue') : '';
    const nominationKey = queryParams.nominationKey;
    const nominationKeyItem = queryParams.nominationItemNumber;
    const nomination= queryParams.nominationNumber;
    return this.httpUtilService.get(Constants.getShipmentdetail(nominationKey,nominationKeyItem,this.userid,nomination).SHIPMENT_DETAIL);
    // return this.httpClient.get("/assets/shipmentlist_1.json").pipe(map((response: any) => response));
  }
  exportReport(type?: any, baseProductCode?:any, batchId?:any,shipmentTab?:any) {
    return this.httpUtilService.get(Constants.exportReport(type, baseProductCode, batchId, this.usergroup,shipmentTab).SEABORNE_REPORT);
  }
  getShipmentfilters(pageid?:string,display?:string) {
       let query = '';
  
    if (pageid !== null && pageid !== undefined && pageid != '') {
      query += `&pageId=${pageid}`;
    }
    //in portside no need to send sales category but for seabourne we need to send sales category BW, if want to combine both then send PS:BW
    if (display !=='PS' && display !== null && display !== undefined && display != '') {
      query += `&salesCategories=${display}`;
    }
    return this.httpUtilService.get(Constants.getShipmenFilters(this.userid,query).filters).pipe(map((response: any) => response)); 
  }
  getShipmentInspectionfilters(display?:string) {
       let query = '';
  
    if (display !=='PS' && display !== null && display !== undefined && display != '') {
      query += `&salesCategories=${display}`;
    }
    return this.httpUtilService.get(Constants.getShipmentInspectionFilters(this.userid,query).filters).pipe(map((response: any) => response));
  }
  saveShipmentDetails(data){
    return this.httpUtilService.patch(Constants.saveShipmentdetail(this.userid).SAVESHIPMENT_DETAIL,data).pipe(map((response: any) => response));

  }
  saveConsignmentPlaceOrder(data){
    return this.httpUtilService.post(Constants.saveConsignmentPlaceOrder(this.userid,this.usergroup).SAVE_CONSIGNMENT_PLACE_ORDER,data).pipe(map((response: any) => response));
  }
  saveShipmentInspectionUpdate(data, isValidateSave: boolean = false){
    return this.httpUtilService.patch(Constants.saveShipmentInspectionUpdate(this.userid, isValidateSave).SAVESHIPMENT_INSP,data).pipe(map((response: any) => response));

  }
  uploaddocument(nominationNo: any,data:any) {
    return this.httpUtilService.post(Constants.uploaddoc(nominationNo,this.userid,data).UPLOAD_DOCUMENT,data);
  }
  uploadInspdocument(nominationNo: any,data:any) {
    return this.httpUtilService.post(Constants.uploadInspdocument(nominationNo,this.userid,data).UPLOAD_INSP_DOCUMENT,data);
  }
  removedocument(nominationNo: any,data:any) {
    return this.httpUtilService.delete(Constants.removedoc(nominationNo,this.userid,data).REMOVE_DOC,data);
  }
  removeBatchScreeningdocument(code: any,data:any) {
    return this.httpUtilService.delete(Constants.removeBatchScreeningdocument(code,this.userid,data).REMOVE_BATCH_DOC,data);
  }
  removeBatchDeliverydocument(code:any,data:any){
    return this.httpUtilService.delete(Constants.removeBatchDeliverydocument(code,this.userid,data).REMOVE_BATCH_DOC,data);
  }
  removeInspdocument(nominationNo: any,data:any) {
    return this.httpUtilService.delete(Constants.removeInspdoc(nominationNo,this.userid,data).REMOVE_INSP_DOC,data);
  }
  dvlTrackingList(data?,searchText?) {
     let query = '';
     this.getGroupCompany();
    if (data?.port !== null && data?.port !== undefined && data?.port != '') {
      query += `&port=${data?.port}`.split(',').join(':');
    }
    if (data?.status !== null && data?.status !== undefined) {
      query += `&status=${data?.status}`.split(',').join(':');
    }
    return this.httpUtilService.get(Constants.getDeliverytrackingList(data,query,searchText,this.userid,this.usergroup).DELIVERYTRAKING_LIST);

    // return this.httpClient.get("/assets/delivery-tracking.json").pipe(map((response: any) => response));
  }
  batchesScreeningList(data?,searchText?,display?) {
    let query = '';
    this.getGroupCompany();
    if (data?.status !== null && data?.status !== undefined) {
      query += `&status=${data?.status}`.split(',').join(':');
    }
   if (data?.port !== null && data?.port !== undefined && data?.port != '') {
     query += `&port=${data?.port}`.split(',').join(':');
   }
   if(searchText !== null && searchText !== undefined && searchText != ''){
    query += `&searchText=${searchText}`;
  }
  if(display === 'bondedwarehouse'){
    query += `&salesArea=BW`;
  }
   return this.httpUtilService.get(Constants.getbatchesScreeningList(data,query,searchText,this.userid,this.usergroup).BATCHESSCREENING_LIST);
  //return this.httpClient.get("/assets/batches-screening.json").pipe(map((response: any) => response));
  }

  saveBatchCompleted(batchId:any,status, data=null){
    return this.httpUtilService.patch(Constants.saveBatchCompleted(batchId,this.userid,status).BATCHCOMPLETED,data);
  }
  // saveShipmentDetails(data){
  //   return this.httpUtilService.patch(Constants.saveShipmentdetail(this.localUserID).SAVESHIPMENT_DETAIL,data).pipe(map((response: any) => response));

  // }
  dvlTrackingDetails(queryParams?:any){
    const baseProductCode = queryParams.baseProductCode;
    const batchId= queryParams.batchId;
    return this.httpUtilService.get(Constants.getDeliverytrackingDetails(baseProductCode,batchId,this.userid,).DELIVERYTRACKING_DETAILS);
    // return this.httpClient.get("/assets/dvl-details.json").pipe(map((response: any) => response));

  }
  saveRecordPickup(data:any,isValidateSave:boolean=false){
    return this.httpUtilService.post(Constants.saveRecordPickUp(this.userid, isValidateSave).RECORD_PICK_UP,data);
  }
  
validateRecordPickup(data: any, type: 'FINALINVOICE_UC1' | 'DRAFTSURVEY_UC7' | 'SCREENINGINVOICE_UC3' | 'CARGOARRIVALINVOICE_UC3' | 'CARGODELIVERYINVOICE_UC3' | 'PORTARRIVALINVOICE_UC3' = 'FINALINVOICE_UC1') {
  const hasSysSubType = typeof data?.sysSubType === 'string' && data.sysSubType.trim() !== '';
    const payload = {
      nomination: data?.nomination ?? data?.nominationNumber,
      nominationKey: data?.nominationKey,
      nominationKeyItem: data?.nominationKeyItem ?? data?.nominationItemNumber,
      batchId : data?.batchId,
      type,
      ...(hasSysSubType ? { sysSubType: data.sysSubType } : {}),
    };
    this.usergroup=this.getGroupCompany();
    return this.httpUtilService.post(
      Constants.validateRecordPickUp(
        this.userid,
        data.nomination,
        data.nominationKey,
        data.nominationKeyItem,
        data.batchId,
        type,
        data.sysSubType,
        this.usergroup
      ).VALIDATE_RECORDS,
      payload
    );
  }

  getInvoiceDetails(data: any, useCaseType: any): Observable<any> {
    const systemSubType = typeof data?.systemSubType === 'string' ? data.systemSubType : undefined;
    return this.httpUtilService.get(
      Constants.getInvoiceDetails(
        data.batchId,
        data.nomination,
        data.nominationKey,
        data.nominationKeyItem,
        useCaseType,
        systemSubType
      ).INVOICE_DETAILS
    );
  }

  getPortInvoices(data: any): Observable<any> {
    return this.httpUtilService.get(
      Constants.getPortInvoices(
        data?.nomination,
        data?.nominationKey,
        data?.nominationKeyItem,
         data?.batchId,
        data?.useCaseType
      ).PORT_INVOICES
    );
  }

  saveInvoice(baseSiteId: string, payload: any): Observable<any> {
    return this.httpUtilService.put(
      Constants.validationResponse(baseSiteId, this.userid, payload.batchId,payload.useCaseType).VALIDATION_RESPONSE,
      payload
    );
  }

  getMasterDataForDvl(pageID){
    return this.httpUtilService.get(Constants.getMasterData(pageID).MASTERDATA);
  }
  batchesScreeningDetails(queryParams?:any){
    const userid = localStorage.getItem('staticUserValue') ? localStorage.getItem('staticUserValue') : '';
    const baseProductCode = queryParams.baseProductCode;
    const batchId= queryParams.batchId;
    return this.httpUtilService.get(Constants.getBatchesScreeningDetails(baseProductCode,batchId,this.userid,).BATCHESSREENING_DETAILS); 
   // return this.httpClient.get("/assets/batches-screening-details.json").pipe(map((response: any) => response)); 
  }  
shipConsignDetails(queryParams:any){
      this.usergroup=this.getGroupCompany();
      const consignNumber = queryParams.searchText;
      const tab=queryParams.shipmentTab
     return this.httpUtilService.get(Constants.getShipConsignDetails(this.userid,this.usergroup,consignNumber,tab).SHIPCONSIGN_DETAILS);  
}  
saveBatchScreeningStatus(batchId:any,status,data=null){
    return this.httpUtilService.patch(Constants.saveBatchScreeningStatus(batchId,this.userid,status).BATCHCOMPLETED,data);
  }
  updateScreeningEntry(data:any,passingArray:any){
    const baseProductCode = passingArray.baseProductCode;
    const batchId= passingArray.batchId;
    return this.httpUtilService.post(Constants.updateScreeningEntry(this.userid,baseProductCode,batchId).BATCHCOMPLETED,data);
  }
  uploadScreeningDocs(batchid:any,data:any){
    return this.httpUtilService.post(Constants.uploadScreeningDocs(this.userid,batchid).upload,data);
  }
  getConsignmentList(data){
     let query = '';
     this.getGroupCompany();
    if (data?.materialId !== null && data?.materialId !== undefined && data?.materialId != '') {
      query += `&materialId=${data?.materialId}`;
    }
    if (data?.shipToUId !== null && data?.shipToUId !== undefined && data?.shipToUId != '') {
      query += `&shipToUId=${data?.shipToUId}`;
    }
    if (data?.searchText !== null && data?.searchText !== undefined && data?.searchText != '') {
      query += `&searchText=${data?.searchText}`;
    }
    return this.httpUtilService.get(Constants.getConsignmentList(this.userid,this.usergroup,data,query).PM_CONSIGN_LIST);
       //return this.httpClient.get("/dvl-details.json").pipe(map((response: any) => response));

  }
    getLocationTabfilters() {    
      return this.httpUtilService.get(Constants.getLocationTabfilters(this.userid,this.usergroup).filters).pipe(map((response: any) => response));
  }
  // getCargoInspectionList(data: any, searchText?: any) {
  //   return this.httpUtilService.get(Constants.getCargoInspectionList().CONTACTS_LIST);
  // }
   getRailDetailsData(queryParams,requestParams){
      this.usergroup=this.getGroupCompany();
      let searchText = requestParams.searchText;   
      let status = requestParams.status;
      let startDate =  requestParams.startDate;
      let endDate =  requestParams.endDate;
      let nominationNo = queryParams.searchText;
      let query=''

    if(status !== null && status != '' && status !== undefined){
       query += `&status=${status}`;
      }
      if (startDate !== null  && startDate !== undefined && endDate !== null && endDate !== undefined && startDate !== '' && endDate !== '' ) {
       query += `&startDate=${startDate}&endDate=${endDate}`;
      }
      if(searchText !== null && searchText !== undefined && searchText !== ''){
         query += `&searchText=${searchText}`;
      }

      return this.httpUtilService.get(Constants.getShipRailDetails(this.userid,this.usergroup,requestParams,nominationNo,query).RAILDETAILS);

    // return this.httpClient.get("/assets/potash.json").pipe(map((response: any) => response));

  }
 
  uploadDeliveryDocs(batchid:any,data:any){
    return this.httpUtilService.patch(Constants.uploadDeliveryDocs(this.userid,batchid).upload,data);
  }
  getaTokenFromCDC(identifier,identifierType){
    return this.httpUtilService.postToken(Constants.getTokenFromCDC(identifier,identifierType).CDC_TOKEN,{});

  }
  loginCDC(email,password){
    return this.httpUtilService.postToken(Constants.logincdc(email,password).CDC_TOKEN,{});


  }


  getShipConsignmentList(data?) {
    let query = ''
    if (data.startDate !== null && data.startDate !== undefined && data.endDate !== null && data.endDate !== undefined && data.startDate !== '' && data.endDate !== '') {
      query += `&startDate=${data.startDate}&endDate=${data.endDate}`;
    }
    if (data.searchText !== null && data.searchText !== undefined && data.searchText !== '') {
      query += `&searchText=${data.searchText}`;
    }
     if (data.sortBy !== null  && data.sortBy !== undefined  &&  data.sortBy !== '' ) {
       query += `&sortBy=${data.sortBy}`;
      }
    this.usergroup=this.getGroupCompany();
    return this.httpUtilService.get(Constants.getShipConsignmentList(this.userid, this.usergroup, data, query).CONSLIST);
  }
   getShipRailList(data?){
    let query=''
    if(data.status !== null && data.status != '' && data.status !== undefined){
       query += `&status=${data.status}`;
      }
      if (data.startDate !== null  && data.startDate !== undefined && data.endDate !== null && data.endDate !== undefined && data.startDate !== '' && data.endDate !== '' ) {
       query += `&startDate=${data.startDate}&endDate=${data.endDate}`;
      }
      if (data.sortBy !== null  && data.sortBy !== undefined  &&  data.sortBy !== '' ) {
       query += `&sortBy=${data.sortBy}`;
      }
      if (data.sortFilter !== null  && data.sortFilter !== undefined &&  data.sortFilter !== '' ) {
       query += `&sortFilter=${data.sortFilter}`;
      }
      if(data.searchText !== null && data.searchText !== undefined && data.searchText !== ''){
         query += `&searchText=${data.searchText}`;
      }
    this.usergroup=this.getGroupCompany();
    return this.httpUtilService.get(Constants.getShipRailList(this.userid,data,this.usergroup,query).RAILLIST);
  }
 getFiltersShipsDocsRails(page){
      return this.httpUtilService.get(Constants.getFiltersShipsDocs(this.userid,page).FILTERS);
  }
  getPlaceOrderDetails(materialId,seqNumber,shipToId) {
    this.usergroup=this.getGroupCompany();
    return this.httpUtilService.get(Constants.getConsignmentPlaceOrderDetails(this.userid, materialId,seqNumber,shipToId).PLACE_ORDER_DETAILS);
      // return this.httpClient.get("/delivery-tracking.json").pipe(map((response: any) => response));

  }

   getQualityInspectionList(data:any,searchText?:any){ 
       let query = ``;
    this.usergroup=this.getGroupCompany();
    if (data?.status !== null && data?.status !== undefined) {
      query += `&status=${data?.status}`.split(',').join(':');
    }
    if (data?.port !== null && data?.port !== undefined && data?.port != '') {
      query += `&port=${data?.port}`.split(',').join(':');
    }
    if(searchText !== null && searchText !== undefined && searchText != ''){
      query += `&searchText=${searchText}`;
    }
    if(data?.currentPage !== null && data?.currentPage !== undefined){
      query += `&currentPage=${data?.currentPage}`;
    }
    return this.httpUtilService.get(Constants.getQualityInspectionList(this.userid,query,this.usergroup).GET_QUALITY_INSPECTION_LIST);
   
   }
  saveLot(data:any,code:any){    
    return this.httpUtilService.post(Constants.saveLot(this.userid,code).SAVE_LOT,data).pipe(map((response: any) => response));
  }
  getQualityInspectionDetails(code:any){
    // read uid straight from the facade instead of this.userid to avoid stale/undefined values on a fresh link
    return this.userAccountFacade.get().pipe(
      switchMap(data => this.httpUtilService.get(Constants.getQualityInspectionDetails(data?.uid,code).QUALITY_INSPECTION_DETAILS))
    );
    
  }
  qualityInspectionCompleted(code:any, data:any){
    return this.httpUtilService.post(Constants.qualityInspectionCompleted(this.userid,code).QUALITY_INSPECTION_COMPLETED,data).pipe(map((response: any) => response));
  }
  deleteQualityAttachment(data:any): any {
    return this.httpUtilService.deleteWithBody(Constants.deleteQualityAttachment(this.userid).DELETE_ATTACHMENT,data);
  }
    setPortInvoiceTypes (value: any[]) {
    this.portInvTypeList.next(value);
  }
    setScreeningInvoiceTypes (value: any[]) {
    this.screeningInvTypeList.next(value);
  }

  logoutUser(){
    let loginDetails = localStorage.getItem('loginData');
    let UID = loginDetails ? JSON.parse(loginDetails).UID : null;
    let UIDobj = new Object({uid:UID});
   return this.httpUtilService.post(Constants.Logout(),UIDobj); 
  }
}

